import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=13021693&scoped=true&"
import script from "./Action.vue?vue&type=script&lang=js&"
export * from "./Action.vue?vue&type=script&lang=js&"
import style0 from "./Action.vue?vue&type=style&index=0&id=13021693&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13021693",
  null
  
)

export default component.exports